export default __webpack_public_path__ + "static/media/IC00038-search_org.76fad941.svg";